import { useState } from "react";
import { Link } from "react-router-dom";
import apiClient from "../api/apiClient";
import { IMAGES } from "../constants/theme";
import "./AuthPage.css";
import LanguageSwitcher from "../components/LanguageSwitcher";
import { useLanguage } from "../i18n/LanguageContext";

const ForgotPassword = () => {
  const { t } = useLanguage();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setMessage("");
    setError("");

    try {
      const { data } = await apiClient.post("/auth/forgot-password", { email });
      setMessage(data.message);
    } catch (requestError) {
      setError(
        requestError.response?.data?.errors?.email?.[0]
          || requestError.response?.data?.message
          || t("The reset email could not be sent. Please try again.")
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wraper auth-page-wrap">
      <LanguageSwitcher className="hpa-auth-language-switch" />
      <div className="page-content auth-page-content" style={{ backgroundImage: `url(${IMAGES.AuthPerformanceBg})` }}>
        <section className="appointment-page auth-hero">
          <div className="container auth-shell auth-shell-login">
            <div className="auth-card">
              <div className="auth-logo-wrap">
                <img src={IMAGES.logo} alt="Hybrid Performance Academy" className="auth-logo hpa-auth-logo" />
              </div>
              <div className="section-head text-center mb-4">
                <span className="auth-step-label">{t("Step 1 of 2")}</span>
                <h3 className="title mb-2">{t("Reset your password")}</h3>
                <p className="auth-help-text">{t("Enter your account email and we will send you a secure reset link.")}</p>
              </div>

              {message && <div className="auth-success" role="status">{message}</div>}
              {error && <div className="auth-error" role="alert">{error}</div>}

              <form onSubmit={submit} className="auth-form">
                <div className="form-group mb-3">
                  <label className="auth-field-label" htmlFor="forgot-email">{t("Email address")}</label>
                  <input
                    id="forgot-email"
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    autoComplete="email"
                    required
                  />
                </div>
                <button type="submit" className={`btn btn-primary btn-lg btn-skew w-100 auth-submit ${loading ? "auth-submit-loading" : ""}`} disabled={loading}>
                  <span>{loading ? t("Sending reset link") : t("Email me a reset link")}</span>
                </button>
              </form>

              <p className="text-center mt-4 mb-0 auth-switch-text">
                <Link to="/auth" className="auth-switch-link">{t("Back to login")}</Link>
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ForgotPassword;
